import React, { useEffect } from 'react'

export const ImageModal = ({ bigImgName, setBigImgName }) => {

    useEffect(() => {
        window.addEventListener("keydown", handleKeyPress);
        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    function handleKeyPress(e) {
        if (e.key == "Escape") setBigImgName(null);
    }

    return (<>
        <div className="tw-fixed tw-h-[100%] tw-w-[100%] tw-z-[18] tw-top-0 tw-left-0 tw-z-10" style={{ backgroundColor: "rgba(0,0,0,0.4)" }} onClick={() => setBigImgName(null)} tabIndex={0} />
        <div className="tw-flex tw-fixed tw-flex-col tw-max-w-[960px] tw-top-0 tw-m-auto tw-z-[19] tw-bottom-0 tw-left-0 tw-right-0 tw-h-fit tw-bg-white tw-fixed">
            <button type="button" className="close popup-close btn-link float-right text-right" onClick={() => setBigImgName(null)}>
                <span className="display-3 tw-text-[3rem] md:tw-text-[4.5rem]" aria-hidden="true">&times;</span>
            </button>
            <img src={`/Content/ProductImages/960x720/${bigImgName}`} />
        </div></>)
}